export default __webpack_public_path__ + "static/media/Y15.275c5173.jpg";